import { Api } from "../utils/Api";

async function fetch(token) {
  try {
    return await Api.get("authServiceUrl", `visibility`, token);
  } catch (e) {
    throw e;
  }
}

async function fetchAll(token) {
  try {
    return await Api.get("authServiceUrl", `visibility/list`, token);
  } catch (e) {
    throw e;
  }
}

async function fetchAllRoles(token) {
  try {
    return await Api.get("authServiceUrl", `visibility/roles`, token);
  } catch (e) {
    throw e;
  }
}

async function update(token, data) {
  try {
    return await Api.post("authServiceUrl", `visibility/update`, token, data);
  } catch (e) {
    throw e;
  }
}

async function create(token, data) {
  try {
    return await Api.post("authServiceUrl", `visibility/create`, token, data);
  } catch (e) {
    throw e;
  }
}

export const visibilityService = {
  fetch,
  fetchAll,
  fetchAllRoles,
  update,
  create,
};
